var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_8909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07642 4.1551L0.959961 11.281V14.8444C0.959961 14.9549 1.0495 15.0444 1.15996 15.0444H4.75671L11.8541 7.93772M8.07642 4.1551L10.9748 1.25294C11.3654 0.861794 11.9993 0.861794 12.3899 1.25294L14.7543 3.62041C15.1442 4.01083 15.1442 4.64328 14.7543 5.03369L11.8541 7.93772M8.07642 4.1551L11.8541 7.93772",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_8909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridEditIcon);
export default __webpack_public_path__ + "static/media/grid-edit-icon.3e37fb65a48ef13c4105493c74909642.svg";
export { ForwardRef as ReactComponent };